import React, { useMemo, useState } from "react";
import "./experienceWheel.css";

const ExperienceWheel = ({ experiences }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const step = useMemo(() => 360 / experiences.length, [experiences.length]);
  const targetAngle = 180; // left center
  const rotation = targetAngle - activeIndex * step;
  const active = experiences[activeIndex];

  return (
    <section className="experience-wheel-section" aria-label="Experience selector">
      <div className="experience-wheel-content">
        <div className="experience-info-card">
          <span className="experience-pill">Experience</span>
          <h2 className="experience-company">{active.company}</h2>
          <p className="experience-role">{active.role}</p>
          <p className="experience-time">{active.time}</p>
          <p className="experience-summary">{active.summary}</p>
          <div className="experience-dots">
            {experiences.map((_, idx) => (
              <button
                key={idx}
                className={`experience-dot ${idx === activeIndex ? "active" : ""}`}
                onClick={() => setActiveIndex(idx)}
                aria-label={`Show ${experiences[idx].company}`}
              />
            ))}
          </div>
        </div>

        <div className="experience-wheel-wrapper">
          <div className="experience-wheel" style={{ "--radius": "220px" }}>
            <div className="wheel-center-dot" />
            {experiences.map((item, idx) => {
              const angle = idx * step;
              return (
                <button
                  key={item.company}
                  className={`wheel-item ${idx === activeIndex ? "active" : ""}`}
                  style={{
                    "--item-angle": `${angle}deg`,
                    "--rotation": `${rotation}deg`,
                    "--accent": item.color
                  }}
                  onClick={() => setActiveIndex(idx)}
                  aria-label={`Select ${item.company}`}
                >
                  <span className="wheel-logo" aria-hidden="true">
                    {item.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceWheel;

